import React from "react"

import { Link } from "gatsby"
import { Row, Col } from "react-bootstrap"

import OnlyImageArticle from "../image"
import LeftImageArticle from "../left-image"
import RightImageArticle from "../right-image"
import Paragraph from "../paragraph"
import SingleImageVideo from "../single-image-video"
import "./combination-of-acfs.scss"
import ColumnLayout from "../column-layout"
import renderElement from "../../../utils/renderElement"
import TitleDescription from "../title-description"
import Company from "../companies/company"
import CTAStreakComponent from "../cta-streak/cta-streak"
import Hero from "../hero/hero"
import Login from "../../login/login"
import SignUp from "../../sign-up/sign-up"
import Separator from "../separator"
import BlogListingPage from "../../blog/blog-list"
import CandidateSearchPage from "../../../pages-sections/search"

const CombinationOfAcfs = ({ data, isBlog, location }) => {
  return (
    <>
      {data.map((article, index) => {
        if (
          article.acf_fc_layout === "loginsignup" &&
          article.login_or_signup === "0"
        ) {
          return <Login key={index} data={article} />
        } else if (article.acf_fc_layout === "candidates_search_and_listings") {
          return <CandidateSearchPage key={index} location={location} />
        } else if (
          article.acf_fc_layout === "loginsignup" &&
          article.login_or_signup === "1"
        ) {
          return <SignUp key={index} data={article} location={location} />
        } else if (article.acf_fc_layout === "image_left_+_text_right") {
          const content = article["image_+_text"][0]
          return (
            <LeftImageArticle
              size="6"
              key={index}
              mb="mb-4"
              offset="0"
              image={content.image}
              isBlog={isBlog}
            >
              <Row>
                <Col lg="10" className="offset-lg-2">
                  {content.title && (
                    <h2
                      className="mb-4"
                      dangerouslySetInnerHTML={renderElement(content.title)}
                    ></h2>
                  )}
                  <div
                    dangerouslySetInnerHTML={renderElement(content.text)}
                  ></div>
                  {content.button_text && content.button_url && (
                    <Link
                      to={content.button_url}
                      className=" btn rounded no-border btn-custom primary py-2 px-5"
                    >
                      <span
                        dangerouslySetInnerHTML={renderElement(
                          content.button_text
                        )}
                      ></span>
                    </Link>
                  )}
                </Col>
              </Row>
            </LeftImageArticle>
          )
        } else if (article?.acf_fc_layout === "single_full_imagevideo") {
          return (
            <SingleImageVideo
              key={index}
              size="6"
              mb="mb-4"
              offset="0"
              article={article}
              isBlog={isBlog}
            />
          )
        } else if (article?.acf_fc_layout === "text_left_+_image_right") {
          const content = article["text_+_image"][0]

          return (
            <RightImageArticle
              size="6"
              offset="0"
              mb="mb-4"
              key={index}
              image={content.image}
              isBlog={isBlog}
            >
              <Row>
                <Col lg="10">
                  {content.title && (
                    <h2
                      className="mb-4"
                      dangerouslySetInnerHTML={renderElement(content.title)}
                    ></h2>
                  )}
                  <div
                    dangerouslySetInnerHTML={renderElement(content.text)}
                  ></div>
                  {content.button_text && content.button_url && (
                    <Link
                      to={content.button_url}
                      className=" btn rounded no-border btn-custom primary py-2"
                    >
                      <span
                        dangerouslySetInnerHTML={renderElement(
                          content.button_text
                        )}
                      ></span>
                    </Link>
                  )}
                </Col>
              </Row>
            </RightImageArticle>
          )
        } else if (article?.acf_fc_layout === "single_paragraphs") {
          return <Paragraph isBlog={isBlog} text={article.copies} key={index} />
        } else if (article.acf_fc_layout === "image") {
          return (
            <OnlyImageArticle
              isBlog={isBlog}
              key={index}
              mb="mb-4"
              image={""}
            />
          )
        } else if (article.acf_fc_layout === "three_column_content") {
          return <ColumnLayout isBlog={isBlog} key={index} data={article} />
        } else if (article.acf_fc_layout === "title_+_description") {
          return (
            <TitleDescription isBlog={isBlog} key={index} article={article} />
          )
        } else if (article.acf_fc_layout === "company_logos") {
          return <Company isBlog={isBlog} article={article} />
        } else if (article.acf_fc_layout === "cta_streak") {
          return (
            <CTAStreakComponent isBlog={isBlog} key={index} article={article} />
          )
        } else if (article.acf_fc_layout === "banner") {
          return (
            <section
              className="hero-section"
              key={index}
              style={{ backgroundColor: article?.background_color }}
            >
              <Hero article={article} />
            </section>
          )
        } else if (article.acf_fc_layout === "seprator") {
          return <Separator isBlog={isBlog} key={index} data={article} />
        } else if (article.acf_fc_layout === "post_listings") {
          return <BlogListingPage location={location} />
        } else return null
      })}
    </>
  )
}

export default CombinationOfAcfs
